import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { list_type, tuple_type, string_type, record_type, int32_type, option_type, class_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class StudyMeshData extends Record {
    constructor(anatomy, maybeDiametricGrowth, lumen, lumenCenterline, wallMaps, wall, wallCenterline, renalArtery, diameterRings) {
        super();
        this.anatomy = anatomy;
        this.maybeDiametricGrowth = maybeDiametricGrowth;
        this.lumen = lumen;
        this.lumenCenterline = lumenCenterline;
        this.wallMaps = wallMaps;
        this.wall = wall;
        this.wallCenterline = wallCenterline;
        this.renalArtery = renalArtery;
        this.diameterRings = diameterRings;
    }
}

export function StudyMeshData_$reflection() {
    return record_type("RAWMap.Client.Visualization.Meshes.Bindings.StudyMeshData", [], StudyMeshData, () => [["anatomy", class_type("Fable.Core.JS.ArrayBuffer")], ["maybeDiametricGrowth", option_type(class_type("Fable.Core.JS.ArrayBuffer"))], ["lumen", class_type("Fable.Core.JS.ArrayBuffer")], ["lumenCenterline", class_type("Fable.Core.JS.ArrayBuffer")], ["wallMaps", class_type("Fable.Core.JS.ArrayBuffer")], ["wall", class_type("Fable.Core.JS.ArrayBuffer")], ["wallCenterline", class_type("Fable.Core.JS.ArrayBuffer")], ["renalArtery", class_type("Fable.Core.JS.ArrayBuffer")], ["diameterRings", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, class_type("Fable.Core.JS.ArrayBuffer")])]]);
}

export class AllMeshData extends Record {
    constructor(currentStudy, previousStudy) {
        super();
        this.currentStudy = currentStudy;
        this.previousStudy = previousStudy;
    }
}

export function AllMeshData_$reflection() {
    return record_type("RAWMap.Client.Visualization.Meshes.Bindings.AllMeshData", [], AllMeshData, () => [["currentStudy", StudyMeshData_$reflection()], ["previousStudy", option_type(StudyMeshData_$reflection())]]);
}

export class AdditionalMeasurementData extends Record {
    constructor(geometryData, growthData) {
        super();
        this.geometryData = geometryData;
        this.growthData = growthData;
    }
}

export function AdditionalMeasurementData_$reflection() {
    return record_type("RAWMap.Client.Visualization.Meshes.Bindings.AdditionalMeasurementData", [], AdditionalMeasurementData, () => [["geometryData", option_type(list_type(tuple_type(string_type, string_type)))], ["growthData", option_type(list_type(tuple_type(string_type, string_type)))]]);
}

